export default {
  title: 'Cadastro',
  EssencialInformation: {
    title: '1. Informações essenciais',
    name: 'Nome',
    document: 'CPF',
    phone: 'Celular',
    email: 'E-mail',
    password: {
      label: 'Senha',
      tooltip: {
        title: 'Importante!',
        text: 'A senha deve conter no mínimo 6 caracteres',
      },
    },
    placeholder: {
      password: '',
      name: 'Ex: Carlos Alberto de Oliveira',
      document: 'Ex: 333.333.333-22',
      phone: 'Ex: (19) 98282-5283',
      email: 'Ex: carlosalbsilva@gmail.com',
    }
  },
  Address: {
    title: '2. Endereço',
    street: 'Endereço',
    number: 'Nro.',
    city: 'Cidade',
    state: 'Estado',
    zipCode: 'CEP',
    neighborhood: 'Bairro',
    additionalInfo: 'Complemento',
    placeholder: {
      street: 'Ex: Rua Professor Atílio Innocenti',
      number: 'Ex: 345',
      city: 'Ex: São Paulo',
      state: 'Ex: São Paulo',
      zipCode: 'Ex: 04538-904',
      neighborhood: 'Ex: Vila das Orquídeas'
    }
  },
  error: 'Ops! Desculpe, mas não foi possível realizar seu cadastro no momento, tente novamente mais tarde.',
  buttons: {
    register: 'REALIZAR CADASTRO',
    continue: 'CONTINUAR',
    finish: 'FINALIZAR CADASTRO',
    change: 'ALTERAR',
    back: 'Voltar'
  },
  login: {
    label: 'Já possui uma conta?',
    signIn: 'Identifique-se aqui.'
  }
};
